import { render, staticRenderFns } from "./CreateLeader.vue?vue&type=template&id=51ac851c&"
import script from "./CreateLeader.vue?vue&type=script&lang=js&"
export * from "./CreateLeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports